var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgMosaicIconSelected = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 11,
    viewBox: "0 0 19 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.641 3.80769V7.19231C13.641 9.29162 11.6738 11 9.25641 11H4.38462C1.96723 11 0 9.29162 0 7.19231V3.80769C0 1.70838 1.96723 0 4.38462 0H9.25641C11.6738 0 13.641 1.70838 13.641 3.80769ZM18.1221 1.89455C17.5843 1.64493 16.9343 1.67282 16.4306 1.96644L15.3199 2.60953C15.1844 2.68822 15.1026 2.82023 15.1026 2.96154V8.03846C15.1026 8.17977 15.1835 8.31178 15.3199 8.39047L16.4296 9.03273C16.7064 9.1935 17.025 9.27464 17.3446 9.27464C17.6106 9.27464 17.8775 9.21883 18.1221 9.10545C18.6638 8.85499 19 8.36847 19 7.83539V3.16461C19 2.63153 18.6638 2.14501 18.1221 1.89455Z",
    fill: "white"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgMosaicIconSelected);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/mosaicIconSelected.d63e0c7522eba689da24ef1a81322413.svg";